export default "__VITE_ASSET__GY8RA8W4__"